var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24.0001,
  r: 24,
  fill: "#CBCBCB"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.7054 22.3697C31.8275 23.167 31.8275 24.8331 30.7054 25.6304L21.5332 32.148C20.209 33.089 18.3748 32.1422 18.3748 30.5177L18.3748 17.4824C18.3748 15.8579 20.209 14.9111 21.5332 15.8521L30.7054 22.3697Z",
  fill: "white"
})));

export default __webpack_public_path__ + "static/media/Play.b22d368c.svg";
export { SvgComponent as ReactComponent };